//import sistema from "./sistema/sifa"
import funciones from './funcion/sifa'
import catalogos from "./catalogos/sifa"


const sifa = {
  funciones: funciones,
  catalogos: catalogos,
  //sistema: sistema
}

export default sifa;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/SIFA/sifaapi.js
// module id = null
// module chunks = 